<template>
  <Modal :id="id" title="Asset Browser" dialog-class="modal-lg">
    <div slot="body" class="asset-browser modal-body modal-form p-4">
      <div class="ab-filters row no-gutters mb-4">
        <div class="col-4">
          <Search v-model="keywords" placeholder="Search by Keyword" />
        </div>
        <div class="col-5 pl-3">
          <Field
            type="select"
            name="category"
            placeholder="Filter by Category"
            v-model="category"
            :options="categories"
          />
        </div>
        <div class="col-3 pl-3">
          <div class="format-toggle row no-gutters">
            <div
              class="format-toggle-item col-6"
              :class="{'active': format == 'grid'}"
              @click="switchFormat('grid')"
            >
              <icon icon="grid" class="icon" />
              <span class="text">Grid</span>
            </div>
            <div
              class="format-toggle-item col-6"
              :class="{'active': format == 'list'}"
              @click="switchFormat('list')"
            >
              <icon icon="list" class="icon" />
              <span class="text">List</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="items.length > 0" v-show="format == 'grid'" class="ab-results ab-results-grid row">
        <div v-for="(item, i) in items" :key="i" class="col-3">
          <div
            class="ab-grid-item"
            :class="{'selected': isSelected(item)}"
            @click="itemSelected(item)"
          >
            <div class="ab-grid-item-inner">
              <div class="overlay">
                <div class="text">
                  <div class="name">{{ item.name }}</div>
                  <div class="file">{{ item.file }}</div>
                </div>
              </div>
              <div
                v-if="item.type == 'IMAGE'"
                class="thumbnail"
                :style="`background-image:url(${item.thumbnail})`"
              ></div>
              <div v-else class="thumbnail bg-dark">
                <icon :icon="item.type.toLowerCase()" class="icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="items.length > 0"
        v-show="format == 'list'"
        class="ab-results ab-results-list mb-4"
      >
        <div class="listable">
          <div class="listable-head">
            <div class="th">&nbsp;</div>
            <div class="th">Name</div>
            <div class="th">File</div>
          </div>
          <div
            v-for="(item, i) in items"
            :key="i"
            class="listable-data"
            :class="{'selected': isSelected(item)}"
            @click="itemSelected(item)"
          >
            <div class="td checkbox">
              <icon icon="check" class="icon" />
            </div>
            <div class="td">{{ item.name }}</div>
            <div class="td">{{ item.file }}</div>
          </div>
        </div>
      </div>

      <div v-if="items.length == 0 && !hideNoResults" class="ab-results row no-gutters">
        <div class="col-12">
          <div
            class="alert alert-info text-center"
          >No results were found. Try broadening your search.</div>
        </div>
      </div>

      <div class="ab-pagination row no-gutters">
        <div class="col-6">
          <a
            v-if="!!selectedItem"
            href="#"
            @click.prevent="submit()"
            class="btn btn-success mr-2"
          >Use Selected</a>
          <a href="#" @click.prevent="close()" class="btn btn-info">Cancel</a>
        </div>
        <div class="col-6 text-right">
          <Pagination
            class="d-inline-block"
            :total="totalPages"
            :value="parseInt(pagination.current)"
            @input="setCurrentPage"
          />
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer d-none"></div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import Pagination from "components/listings/Pagination";
import Search from "components/listings/Search";
export default {
  mixins: [ModalMixin],
  components: { Pagination, Search },
  data() {
    return {
      id: "asset-browser-modal",
      keywords: "",
      categories: [],
      category: null,
      pagination: {
        current: 1,
        per_page: 12
      },
      sort: {
        column: "name",
        dir: "asc"
      },
      items: [],
      totalItems: 0,
      totalPages: 0,
      hideNoResults: true,
      selectedItem: null,
      format: "grid"
    };
  },
  computed: {
    types() {
      return _.has(this.options, "types") && _.isArray(this.options.types)
        ? this.options.types
        : [];
    }
  },
  watch: {
    keywords(val) {
      this.refresh();
    },
    category(val) {
      this.refresh();
    },
    pagination: {
      handler: function(val) {
        this.refresh();
      },
      deep: true
    }
  },
  methods: {
    load() {
      this.axios
        .get(this.route("admin.assets.browse.categories"))
        .then(response => {
          this.categories = response.data;
        })
        .catch(() => {});
    },
    refresh: _.debounce(function() {
      this.selectedItem = null;
      this.axios
        .get(this.route("admin.assets.browse"), {
          params: this.queryParams()
        })
        .then(response => {
          this.totalItems = response.data.total_results;
          this.totalPages = response.data.total_pages;
          this.items = response.data.results;
          this.hideNoResults = false;
        })
        .catch(() => {});
    }, 300),
    queryParams() {
      return {
        ...(this.keywords.length > 0 ? { keywords: this.keywords } : {}),
        ...(this.types.length > 0 ? { "filters[type]": this.types } : {}),
        ...(!!this.category ? { "filters[category]": [this.category] } : {}),
        ...{ "pagination[current]": this.pagination.current },
        ...{ "pagination[per_page]": this.pagination.per_page },
        ...{ "sort[column]": this.sort.column },
        ...{ "sort[dir]": this.sort.dir }
      };
    },
    setCurrentPage(val) {
      this.pagination.current = val;
    },
    itemSelected(item) {
      if (this.isSelected(item)) {
        this.selectedItem = null;
      } else {
        this.selectedItem = item;
      }
    },
    isSelected(item) {
      return !!this.selectedItem && this.selectedItem.id == item.id;
    },
    switchFormat(format) {
      this.format = format;
    },
    submit() {
      if (!this.selectedItem) {
        alert("Please select an asset to continue.");
      } else {
        this.resolve(this.selectedItem);
      }
    }
  },
  mounted() {
    this.load();
    this.refresh();
  }
};
</script>